__webpack_require__.p = "/interactive/basf/batteries/";